/**
 * Diccionario i18n del SetupWizard y del modal de Nodo.
 *
 * Clave = texto español EXACTO tal como aparece en el código (estilo gettext).
 * Solo columna pt (Fase 1).
 *
 * Terminología pt-BR canónica del proyecto:
 *   Ponto de Venda, operador de caixa, dispositivo, cupom, campanha.
 *
 * Claves ya en otros diccionarios (NO se re-declaran aquí):
 *   Guardar, Cancelar, Seleccionar..., Heredar del padre, sin datos, sin config,
 *   Punto de Venta, Operador, Representante, Identidad, Contacto, Dirección,
 *   Nombre, Tipo, País, Moneda, Idioma, Estado, Siguiente, Atrás, Confirmar,
 *   Resumen, Confirmar datos, sin imagen, Cambiar, Reset,
 *   Nuevo Nodo, Editar Nodo, Nodo creado, Nodo actualizado,
 *   Promotor Digital, Cuenta Interbancaria, Autorización / Licencia,
 *   Fisico (Local con direccion), Ambulante (Vendedores moviles),
 *   Sistema (Operaciones automaticas), Online (Pasarelas de pago),
 *   requerido, Heredar, Buscando..., Sin resultados, + Crear nuevo.
 */

export const DICCIONARIO_WIZARD = {
    'QR persistente para abrir en la Smart TV': { pt: 'QR persistente para abrir na Smart TV', en: 'Persistent QR to open on the Smart TV', ru: 'Постоянный QR для открытия на Smart TV' },
    'Link de acceso de un solo uso': { pt: 'Link de acesso de uso único', en: 'Single-use access link', ru: 'Одноразовая ссылка доступа' },
    'APK horneado para instalar en el aparato': { pt: 'APK preparado para instalar no aparelho', en: 'Prebuilt APK to install on the device', ru: 'Готовый APK для установки на устройство' },
    'Se generará': { pt: 'Será gerado', en: 'Will be generated', ru: 'Будет сгенерировано' },
    'Requiere impresora conectada al equipo': { pt: 'Requer impressora conectada ao equipamento', en: 'Requires a printer connected to the device', ru: 'Требуется принтер, подключённый к устройству' },

    // ── nodo-modal.js — Identidad ────────────────────────────────────────────
    'Tipo *': { pt: 'Tipo *', en: 'Type *', ru: 'Тип *' },
    'Nombre del nodo': { pt: 'Nome do nó', en: 'Node name', ru: 'Название узла' },
    'Código (opcional)': { pt: 'Código (opcional)', en: 'Code (optional)', ru: 'Код (необязательно)' },
    'Ej: OP-LIMA, PV-001': { pt: 'Ex.: OP-LIMA, PV-001', en: 'E.g.: OP-LIMA, PV-001', ru: 'Напр.: OP-LIMA, PV-001' },
    'Atajo para localizar este nodo en búsquedas.': {
        pt: 'Atalho para localizar este nó nas buscas.',
        en: 'Shortcut to locate this node in searches.',
        ru: 'Ярлык для поиска этого узла.',
    },
    'Email o teléfono': { pt: 'E-mail ou telefone', en: 'Email or phone', ru: 'Email или телефон' },
    'Teléfono de contacto (con código de país)': {
        pt: 'Telefone de contato (com código do país)',
        en: 'Contact phone (with country code)',
        ru: 'Контактный телефон (с кодом страны)',
    },

    // ── nodo-modal.js — Localización ─────────────────────────────────────────
    'País': { pt: 'País', en: 'Country', ru: 'Страна' },
    'Define documentos fiscales, bancos y régimen tributario. Vacío = hereda del ancestro.': {
        pt: 'Define documentos fiscais, bancos e regime tributário. Vazio = herda do ancestral.',
        en: 'Defines tax documents, banks and tax regime. Empty = inherits from the ancestor.',
        ru: 'Определяет налоговые документы, банки и налоговый режим. Пусто = наследуется от предка.',
    },
    'Idioma del sistema': { pt: 'Idioma do sistema', en: 'System language', ru: 'Язык системы' },
    'Idioma para mensajes, interfaz de caja y sorteos. Vacío = hereda del ancestro más cercano.': {
        pt: 'Idioma para mensagens, interface de caixa e sorteios. Vazio = herda do ancestral mais próximo.',
        en: 'Language for messages, till interface and draws. Empty = inherits from the nearest ancestor.',
        ru: 'Язык для сообщений, интерфейса кассы и розыгрышей. Пусто = наследуется от ближайшего предка.',
    },
    'Moneda para formateo de montos y estadísticas. Vacío = hereda del ancestro más cercano.': {
        pt: 'Moeda para formatação de valores e estatísticas. Vazio = herda do ancestral mais próximo.',
        en: 'Currency for amount formatting and statistics. Empty = inherits from the nearest ancestor.',
        ru: 'Валюта для форматирования сумм и статистики. Пусто = наследуется от ближайшего предка.',
    },

    // ── nodo-modal.js — Ubicación física ─────────────────────────────────────
    'Dirección': { pt: 'Endereço', en: 'Address', ru: 'Адрес' },
    'Dirección física': { pt: 'Endereço físico', en: 'Physical address', ru: 'Физический адрес' },
    'Ubicación y Horario': { pt: 'Localização e Horário', en: 'Location and Hours', ru: 'Местоположение и часы работы' },
    'Datos operativos del punto de venta físico.': {
        pt: 'Dados operacionais do ponto de venda físico.',
        en: 'Operational data of the physical point of sale.',
        ru: 'Операционные данные физической точки продаж.',
    },
    'Departamento / Estado / Región': { pt: 'Departamento / Estado / Região', en: 'Department / State / Region', ru: 'Департамент / Штат / Регион' },
    'Ej: AMAZONAS - UTCUBAMBA - BAGUA GRANDE': {
        pt: 'Ex.: AMAZONAS - UTCUBAMBA - BAGUA GRANDE',
        en: 'E.g.: AMAZONAS - UTCUBAMBA - BAGUA GRANDE',
        ru: 'Напр.: AMAZONAS - UTCUBAMBA - BAGUA GRANDE',
    },
    'Latitud': { pt: 'Latitude', en: 'Latitude', ru: 'Широта' },
    'Longitud': { pt: 'Longitude', en: 'Longitude', ru: 'Долгота' },
    'Horario de Operación': { pt: 'Horário de Operação', en: 'Operating Hours', ru: 'Часы работы' },
    '07:00 - 23:00': { pt: '07:00 - 23:00', en: '07:00 - 23:00', ru: '07:00 - 23:00' },
    'Días de Operación': { pt: 'Dias de Operação', en: 'Operating Days', ru: 'Дни работы' },
    'Lunes a Domingo': { pt: 'Segunda a Domingo', en: 'Monday to Sunday', ru: 'С понедельника по воскресенье' },
    'Teléfono del Local': { pt: 'Telefone do Local', en: 'Venue Phone', ru: 'Телефон точки' },
    'Email del Local': { pt: 'E-mail do Local', en: 'Venue Email', ru: 'Email точки' },
    'Documento legal que se expone en el local. El sistema alertará cuando esté por vencer.': {
        pt: 'Documento legal exposto no local. O sistema alertará quando estiver próximo do vencimento.',
        en: 'Legal document displayed at the venue. The system will alert when it is about to expire.',
        ru: 'Юридический документ, размещённый в точке. Система предупредит о скором истечении срока.',
    },
    'Código / Número de Autorización': { pt: 'Código / Número de Autorização', en: 'Authorization Code / Number', ru: 'Код / Номер разрешения' },
    'Sin información': { pt: 'Sem informação', en: 'No information', ru: 'Нет информации' },
    'En Trámite': { pt: 'Em Tramitação', en: 'In Process', ru: 'В процессе оформления' },
    'Vencida': { pt: 'Vencida', en: 'Expired', ru: 'Истёкла' },
    'Fecha de Emisión': { pt: 'Data de Emissão', en: 'Issue Date', ru: 'Дата выдачи' },
    'Fecha de Vencimiento': { pt: 'Data de Vencimento', en: 'Expiration Date', ru: 'Дата истечения срока' },
    'Se generará una alerta operativa 30 días antes del vencimiento.': {
        pt: 'Será gerado um alerta operacional 30 dias antes do vencimento.',
        en: 'An operational alert will be generated 30 days before expiration.',
        ru: 'Операционное уведомление будет создано за 30 дней до истечения срока.',
    },

    // ── nodo-modal.js — Operación ────────────────────────────────────────────
    'Wallet (Recargas)': { pt: 'Wallet (Recargas)', en: 'Wallet (Top-ups)', ru: 'Кошелёк (пополнения)' },
    'Se hereda a nodos hijos. Dejar vacío para heredar del padre.': {
        pt: 'É herdado pelos nós filhos. Deixar vazio para herdar do pai.',
        en: 'Inherited by child nodes. Leave empty to inherit from the parent.',
        ru: 'Наследуется дочерними узлами. Оставьте пустым, чтобы наследовать от родителя.',
    },
    '50, 100, 500, 1000, 2000, 5000': { pt: '50, 100, 500, 1000, 2000, 5000', en: '50, 100, 500, 1000, 2000, 5000', ru: '50, 100, 500, 1000, 2000, 5000' },
    'Enteros en la unidad mínima de la moneda (centavos). Ej: 50 = R$ 0,50 / 100 = R$ 1,00 / 5000 = R$ 50,00. Para CLP/COP coincide con el valor entero (50 = $50).': {
        pt: 'Inteiros na unidade mínima da moeda (centavos). Ex.: 50 = R$ 0,50 / 100 = R$ 1,00 / 5000 = R$ 50,00. Para CLP/COP coincide com o valor inteiro (50 = $50).',
        en: 'Integers in the currency\'s minimum unit (cents). E.g.: 50 = R$ 0.50 / 100 = R$ 1.00 / 5000 = R$ 50.00. For CLP/COP it matches the whole value (50 = $50).',
        ru: 'Целые числа в минимальной единице валюты (центы). Напр.: 50 = R$ 0,50 / 100 = R$ 1,00 / 5000 = R$ 50,00. Для CLP/COP совпадает с целым значением (50 = $50).',
    },
    'Denominación (botones de monto)': { pt: 'Denominação (botões de valor)', en: 'Denomination (amount buttons)', ru: 'Номинал (кнопки сумм)' },
    'Tipo de identificador del cliente': { pt: 'Tipo de identificador do cliente', en: 'Customer identifier type', ru: 'Тип идентификатора клиента' },
    'Teléfono celular': { pt: 'Telefone celular', en: 'Mobile phone', ru: 'Мобильный телефон' },
    'Correo electrónico': { pt: 'Correio eletrônico', en: 'Email address', ru: 'Электронная почта' },
    'Documento de identidad (DNI/CE)': { pt: 'Documento de identidade (CPF/RG)', en: 'ID document (DNI/CE)', ru: 'Документ, удостоверяющий личность (DNI/CE)' },
    'Código interno del operador': { pt: 'Código interno do operador', en: 'Operator internal code', ru: 'Внутренний код оператора' },
    'Cómo se identifica al cliente en la caja. Default: teléfono.': {
        pt: 'Como o cliente é identificado no caixa. Padrão: telefone.',
        en: 'How the customer is identified at the till. Default: phone.',
        ru: 'Как клиент идентифицируется в кассе. По умолчанию: телефон.',
    },
    'Acciones después de recarga': { pt: 'Ações após recarga', en: 'Actions after top-up', ru: 'Действия после пополнения' },
    'Link de juego': { pt: 'Link do jogo', en: 'Game link', ru: 'Ссылка на игру' },
    'Referidos (cliente nuevo)': { pt: 'Indicações (cliente novo)', en: 'Referrals (new customer)', ru: 'Рефералы (новый клиент)' },
    'Widgets que aparecen tras un depósito exitoso.': {
        pt: 'Widgets exibidos após um depósito bem-sucedido.',
        en: 'Widgets shown after a successful deposit.',
        ru: 'Виджеты, отображаемые после успешного депозита.',
    },
    'Juegos y Restricciones': { pt: 'Jogos e Restrições', en: 'Games and Restrictions', ru: 'Игры и ограничения' },
    'Series de tickets por canal': { pt: 'Séries de tickets por canal', en: 'Ticket series by channel', ru: 'Серии билетов по каналам' },
    'Dejá en "Heredar" para usar la serie default global': {
        pt: 'Deixe em "Herdar" para usar a série padrão global',
        en: 'Leave on "Inherit" to use the global default series',
        ru: 'Оставьте «Наследовать», чтобы использовать глобальную серию по умолчанию',
    },
    'Bearer': { pt: 'Bearer', en: 'Bearer', ru: 'Bearer' },
    '+ Agregar partner': { pt: '+ Adicionar parceiro', en: '+ Add partner', ru: '+ Добавить партнёра' },

    // ── nodo-modal.js — Finanzas ─────────────────────────────────────────────
    'Datos Fiscales': { pt: 'Dados Fiscais', en: 'Tax Data', ru: 'Налоговые данные' },
    'Identificación tributaria del titular. Las opciones se ajustan al país seleccionado.': {
        pt: 'Identificação tributária do titular. As opções se ajustam ao país selecionado.',
        en: 'Tax identification of the holder. Options adjust to the selected country.',
        ru: 'Налоговая идентификация владельца. Параметры зависят от выбранной страны.',
    },
    'Razón Social / Nombre Fiscal': { pt: 'Razão Social / Nome Fiscal', en: 'Legal Name / Tax Name', ru: 'Юридическое наименование / Налоговое имя' },
    'Razón social del titular': { pt: 'Razão social do titular', en: 'Holder\'s legal name', ru: 'Юридическое наименование владельца' },
    'Tipo de Documento Fiscal': { pt: 'Tipo de Documento Fiscal', en: 'Tax Document Type', ru: 'Тип налогового документа' },
    'Número de Documento': { pt: 'Número do Documento', en: 'Document Number', ru: 'Номер документа' },
    'Dirección Fiscal': { pt: 'Endereço Fiscal', en: 'Tax Address', ru: 'Налоговый адрес' },
    'Dirección legal / sede tributaria': { pt: 'Endereço legal / sede tributária', en: 'Legal address / tax domicile', ru: 'Юридический адрес / налоговый адрес' },
    'Régimen Tributario': { pt: 'Regime Tributário', en: 'Tax Regime', ru: 'Налоговый режим' },
    'Datos Bancarios': { pt: 'Dados Bancários', en: 'Bank Data', ru: 'Банковские данные' },
    'Cuenta para liquidaciones y pagos. Las opciones se ajustan al país seleccionado.': {
        pt: 'Conta para liquidações e pagamentos. As opções se ajustam ao país selecionado.',
        en: 'Account for settlements and payments. Options adjust to the selected country.',
        ru: 'Счёт для расчётов и платежей. Параметры зависят от выбранной страны.',
    },
    'Billetera digital': { pt: 'Carteira digital', en: 'Digital wallet', ru: 'Цифровой кошелёк' },
    'Chave PIX en Brasil · Yape/Plin en Perú': { pt: 'Chave PIX no Brasil · Yape/Plin no Peru', en: 'PIX key in Brazil · Yape/Plin in Peru', ru: 'Ключ PIX в Бразилии · Yape/Plin в Перу' },
    'Clave/chave o celular de la billetera': {
        pt: 'Chave PIX ou celular da carteira',
        en: 'Wallet key or phone number',
        ru: 'Ключ кошелька или номер телефона',
    },
    'Banco': { pt: 'Banco', en: 'Bank', ru: 'Банк' },
    'Tipo de Cuenta': { pt: 'Tipo de Conta', en: 'Account Type', ru: 'Тип счёта' },
    'Número de Cuenta': { pt: 'Número de Conta', en: 'Account Number', ru: 'Номер счёта' },
    'Titular de la Cuenta': { pt: 'Titular da Conta', en: 'Account Holder', ru: 'Владелец счёта' },
    'Nombre del titular (si difiere de la razón social)': {
        pt: 'Nome do titular (se diferir da razão social)',
        en: 'Holder\'s name (if it differs from the legal name)',
        ru: 'Имя владельца (если отличается от юридического наименования)',
    },
    'Techo de comisión para promotores': { pt: 'Teto de comissão para promotores', en: 'Commission cap for promoters', ru: 'Предел комиссии для промоутеров' },
    'doble seguridad: nadie en su red puede dar más que esto a un promotor — vacío = sin techo': {
        pt: 'dupla segurança: ninguém na sua rede pode dar mais que isso a um promotor — vazio = sem teto',
        en: 'double safeguard: no one in your network can give more than this to a promoter — empty = no cap',
        ru: 'двойная защита: никто в вашей сети не может дать промоутеру больше этого — пусто = без предела',
    },
    'Pasarela de Pagos': { pt: 'Gateway de Pagamentos', en: 'Payment Gateway', ru: 'Платёжный шлюз' },
    'Pagos digitales (PIX, etc.). Se hereda a nodos hijos.': {
        pt: 'Pagamentos digitais (PIX, etc.). É herdado pelos nós filhos.',
        en: 'Digital payments (PIX, etc.). Inherited by child nodes.',
        ru: 'Цифровые платежи (PIX и т. д.). Наследуется дочерними узлами.',
    },
    'Límites globales': { pt: 'Limites globais', en: 'Global limits', ru: 'Глобальные лимиты' },
    'Recarga mín (centavos)': { pt: 'Recarga mín (centavos)', en: 'Min top-up (cents)', ru: 'Мин. пополнение (центы)' },
    'Recarga máx (centavos)': { pt: 'Recarga máx (centavos)', en: 'Max top-up (cents)', ru: 'Макс. пополнение (центы)' },
    'Retiro mín (centavos)': { pt: 'Saque mín (centavos)', en: 'Min withdrawal (cents)', ru: 'Мин. вывод (центы)' },
    'Retiro máx / transacción': { pt: 'Saque máx / transação', en: 'Max withdrawal / transaction', ru: 'Макс. вывод / транзакция' },
    'Retiro máx diario / cliente': { pt: 'Saque máx diário / cliente', en: 'Max daily withdrawal / customer', ru: 'Макс. вывод в день / клиент' },
    'Retiro inmediato': { pt: 'Saque imediato', en: 'Instant withdrawal', ru: 'Мгновенный вывод' },
    'Campos requeridos al jugador': { pt: 'Campos obrigatórios do jogador', en: 'Fields required from the player', ru: 'Обязательные поля для игрока' },
    'Recarga bancaria en VLT': { pt: 'Recarga bancária na VLT', en: 'Bank top-up on VLT', ru: 'Банковское пополнение на VLT' },
    'Permitir recarga anónima': { pt: 'Permitir recarga anônima', en: 'Allow anonymous top-up', ru: 'Разрешить анонимное пополнение' },
    'Exigir cuenta del jugador': { pt: 'Exigir conta do jogador', en: 'Require player account', ru: 'Требовать аккаунт игрока' },
    'Con cuenta exigida, la terminal pide teléfono y PIN antes de iniciar una recarga bancaria. Retiros, pagos pendientes y cobros en caja no cambian.': {
        pt: 'Com conta exigida, o terminal pede telefone e PIN antes de iniciar uma recarga bancária. Saques, pagamentos pendentes e recebimentos no caixa não mudam.',
        en: 'With account required, the terminal asks for phone and PIN before starting a bank top-up. Withdrawals, pending payments and counter payouts are unchanged.',
        ru: 'При требовании аккаунта терминал запрашивает телефон и PIN перед банковским пополнением. Выводы, ожидающие платежи и выплаты в кассе не меняются.',
    },
    'Configura primero una pasarela (propia o heredada) para gobernar la recarga VLT': {
        pt: 'Configure primeiro um gateway (próprio ou herdado) para governar a recarga VLT',
        en: 'Set up a payment gateway first (own or inherited) to govern VLT top-ups',
        ru: 'Сначала настройте платёжный шлюз (свой или унаследованный), чтобы управлять пополнением VLT',
    },
    'En recarga:': { pt: 'Na recarga:', en: 'On top-up:', ru: 'При пополнении:' },
    'En retiro:': { pt: 'No saque:', en: 'On withdrawal:', ru: 'При выводе:' },

    // ── nodo-modal.js — Canales y marca ──────────────────────────────────────
    'Canal WhatsApp habilitado': { pt: 'Canal WhatsApp habilitado', en: 'WhatsApp channel enabled', ru: 'Канал WhatsApp включён' },
    'Si está habilitado, el POS podrá enviar el ticket al WhatsApp del cliente (motivo de reimpresión o venta al wallet).': {
        pt: 'Se habilitado, o POS poderá enviar o ticket pelo WhatsApp do cliente (motivo de reimpressão ou venda no wallet).',
        en: 'If enabled, the POS can send the ticket to the customer\'s WhatsApp (reprint reason or wallet sale).',
        ru: 'Если включено, POS сможет отправлять билет в WhatsApp клиента (повторная печать или продажа в кошелёк).',
    },
    '999888777 (opcional — número del comercio)': {
        pt: '999888777 (opcional — número do comércio)',
        en: '999888777 (optional — business number)',
        ru: '999888777 (необязательно — номер точки)',
    },
    'Número del comercio (sin prefijo de país). Opcional: si está vacío, el POS pedirá el número al cliente al enviar.': {
        pt: 'Número do comércio (sem prefixo do país). Opcional: se vazio, o POS pedirá o número ao cliente ao enviar.',
        en: 'Business number (without country prefix). Optional: if empty, the POS will ask the customer for the number when sending.',
        ru: 'Номер точки (без кода страны). Необязательно: если пусто, POS запросит номер у клиента при отправке.',
    },
    'Branding': { pt: 'Branding', en: 'Branding', ru: 'Брендинг' },
    'Logos personalizados del operador. Se heredan a nodos hijos.': {
        pt: 'Logos personalizados do operador. São herdados pelos nós filhos.',
        en: 'Operator\'s custom logos. Inherited by child nodes.',
        ru: 'Пользовательские логотипы оператора. Наследуются дочерними узлами.',
    },
    'Logo Splash': { pt: 'Logo Splash', en: 'Splash Logo', ru: 'Логотип заставки' },
    'Logo Login': { pt: 'Logo Login', en: 'Login Logo', ru: 'Логотип входа' },
    'Logo Ticket': { pt: 'Logo Ticket', en: 'Ticket Logo', ru: 'Логотип билета' },
    'Efecto Shine (Splash y Login)': { pt: 'Efeito Shine (Splash e Login)', en: 'Shine Effect (Splash and Login)', ru: 'Эффект блеска (заставка и вход)' },
    'Color 1': { pt: 'Cor 1', en: 'Color 1', ru: 'Цвет 1' },
    'Color 2': { pt: 'Cor 2', en: 'Color 2', ru: 'Цвет 2' },
    'Solo aplica a logos SVG. PNG/WebP se muestran sin efecto.': {
        pt: 'Aplica-se apenas a logos SVG. PNG/WebP são exibidos sem efeito.',
        en: 'Applies only to SVG logos. PNG/WebP are shown without effect.',
        ru: 'Применяется только к SVG-логотипам. PNG/WebP отображаются без эффекта.',
    },
    'Píxel de Meta / GTM': { pt: 'Pixel de Meta / GTM', en: 'Meta / GTM Pixel', ru: 'Пиксель Meta / GTM' },
    'Píxel de seguimiento del operador para optimizar su pauta paga en Meta/Google. Se hereda a los nodos hijos (un Promotor Digital sin píxel propio usa el de su operador). Solo se inyecta a visitantes que vienen de una campaña.': {
        pt: 'Pixel de rastreamento do operador para otimizar sua mídia paga em Meta/Google. É herdado pelos nós filhos (um Promotor Digital sem pixel próprio usa o do seu operador). Só é injetado em visitantes que vêm de uma campanha.',
        en: 'Operator\'s tracking pixel to optimize its paid advertising on Meta/Google. Inherited by child nodes (a Digital Promoter without its own pixel uses its operator\'s). Only injected for visitors coming from a campaign.',
        ru: 'Пиксель отслеживания оператора для оптимизации платной рекламы в Meta/Google. Наследуется дочерними узлами (цифровой промоутер без собственного пикселя использует пиксель своего оператора). Внедряется только для посетителей из кампании.',
    },
    'Píxel de Meta (ID)': { pt: 'Pixel de Meta (ID)', en: 'Meta Pixel (ID)', ru: 'Пиксель Meta (ID)' },
    '123456789012345': { pt: '123456789012345', en: '123456789012345', ru: '123456789012345' },
    'Solo dígitos (15-16). ID de Facebook/Meta Pixel.': {
        pt: 'Somente dígitos (15-16). ID do Facebook/Meta Pixel.',
        en: 'Digits only (15-16). Facebook/Meta Pixel ID.',
        ru: 'Только цифры (15-16). ID Facebook/Meta Pixel.',
    },
    'GTM Container ID': { pt: 'GTM Container ID', en: 'GTM Container ID', ru: 'GTM Container ID' },
    'Formato GTM-XXXXXXX. Google Tag Manager.': {
        pt: 'Formato GTM-XXXXXXX. Google Tag Manager.',
        en: 'Format GTM-XXXXXXX. Google Tag Manager.',
        ru: 'Формат GTM-XXXXXXX. Google Tag Manager.',
    },

    // ── nodo-modal.js — Ticket POS ───────────────────────────────────────────
    'Ticket POS (legal + impresión)': { pt: 'Ticket POS (legal + impressão)', en: 'POS Ticket (legal + printing)', ru: 'Билет POS (юридический + печать)' },
    'Estos campos viajan al POS Android y se imprimen en el ticket térmico. Razón social, número fiscal, licencia y teléfono se toman de los accordions Fiscales/Autorización/Canales (SSOT — no se duplican aquí).': {
        pt: 'Esses campos são enviados ao POS Android e impressos no ticket térmico. Razão social, número fiscal, licença e telefone são obtidos dos accordions Fiscais/Autorização/Canais (SSOT — não se duplicam aqui).',
        en: 'These fields travel to the Android POS and are printed on the thermal ticket. Legal name, tax number, license and phone are taken from the Tax/Authorization/Channels accordions (SSOT — not duplicated here).',
        ru: 'Эти поля передаются в Android POS и печатаются на термобилете. Юридическое наименование, налоговый номер, лицензия и телефон берутся из аккордеонов «Налоги/Разрешение/Каналы» (SSOT — здесь не дублируются).',
    },
    'Validez del premio (días)': { pt: 'Validade do prêmio (dias)', en: 'Prize validity (days)', ru: 'Срок действия приза (дней)' },
    'Aparece en el texto legal del ticket (ej: "Premio válido 30 días desde el sorteo"). Vacío = heredar (default 30).': {
        pt: 'Aparece no texto legal do ticket (ex.: "Prêmio válido 30 dias a partir do sorteio"). Vazio = herdar (padrão 30).',
        en: 'Appears in the ticket\'s legal text (e.g.: "Prize valid for 30 days from the draw"). Empty = inherit (default 30).',
        ru: 'Отображается в юридическом тексте билета (напр.: «Приз действителен 30 дней с момента розыгрыша»). Пусто = наследовать (по умолчанию 30).',
    },
    'Texto adicional legal': { pt: 'Texto legal adicional', en: 'Additional legal text', ru: 'Дополнительный юридический текст' },
    'Ej: Consultas 24h al 0800-xxx-xxxx': { pt: 'Ex.: Consultas 24h pelo 0800-xxx-xxxx', en: 'E.g.: 24h inquiries at 0800-xxx-xxxx', ru: 'Напр.: Справки 24ч по 0800-xxx-xxxx' },
    'Se concatena al final del bloque legal con separador "·". Opcional — vacío = sin texto extra.': {
        pt: 'É concatenado ao final do bloco legal com separador "·". Opcional — vazio = sem texto extra.',
        en: 'Concatenated at the end of the legal block with separator "·". Optional — empty = no extra text.',
        ru: 'Добавляется в конец юридического блока с разделителем «·». Необязательно — пусто = без дополнительного текста.',
    },
    'Branding del ticket': { pt: 'Branding do ticket', en: 'Ticket branding', ru: 'Брендинг билета' },
    'Nombre del operador en el pie': { pt: 'Nome do operador no rodapé', en: 'Operator name in the footer', ru: 'Имя оператора в нижнем колонтитуле' },
    'Ej: Lotería Nacional SAC': { pt: 'Ex.: Loteria Nacional SAC', en: 'E.g.: Lotería Nacional SAC', ru: 'Напр.: Lotería Nacional SAC' },
    'Aparece en el pie del ticket. Vacío = heredar del ancestro.': {
        pt: 'Aparece no rodapé do ticket. Vazio = herdar do ancestral.',
        en: 'Appears in the ticket footer. Empty = inherit from the ancestor.',
        ru: 'Отображается в нижнем колонтитуле билета. Пусто = наследовать от предка.',
    },
    'URL base para QR de resultados': { pt: 'URL base para QR de resultados', en: 'Base URL for results QR', ru: 'Базовый URL для QR результатов' },
    'https://resultados.loteriaejemplo.com': {
        pt: 'https://resultados.loteriaejemplo.com',
        en: 'https://resultados.loteriaejemplo.com',
        ru: 'https://resultados.loteriaejemplo.com',
    },
    'Solo dominio raíz — el POS compone': {
        pt: 'Somente domínio raiz — o POS compõe',
        en: 'Root domain only — the POS composes',
        ru: 'Только корневой домен — POS формирует',
    },
    '. Si hay QR, el Code128 se omite por default (ahorro de papel).': {
        pt: '. Se houver QR, o Code128 é omitido por padrão (economia de papel).',
        en: '. If there is a QR, Code128 is omitted by default (paper saving).',
        ru: '. Если есть QR, Code128 по умолчанию опускается (экономия бумаги).',
    },
    'Footer extra': { pt: 'Rodapé extra', en: 'Extra footer', ru: 'Дополнительный колонтитул' },
    'Ej: Síguenos @loteriax': { pt: 'Ex.: Siga-nos @loteriax', en: 'E.g.: Follow us @loteriax', ru: 'Напр.: Подписывайтесь @loteriax' },
    'Texto decorativo al final del ticket. Opcional.': {
        pt: 'Texto decorativo no final do ticket. Opcional.',
        en: 'Decorative text at the end of the ticket. Optional.',
        ru: 'Декоративный текст в конце билета. Необязательно.',
    },
    'Imprimir Code128 (código de barras)': { pt: 'Imprimir Code128 (código de barras)', en: 'Print Code128 (barcode)', ru: 'Печатать Code128 (штрихкод)' },
    'Heredar (default: si no hay QR, sí; si hay QR, no)': {
        pt: 'Herdar (padrão: se não houver QR, sim; se houver QR, não)',
        en: 'Inherit (default: if no QR, yes; if QR, no)',
        ru: 'Наследовать (по умолчанию: если нет QR — да; если есть QR — нет)',
    },
    'Regla dura: el ticket nunca sale sin algún código escaneable. Si no hay QR y se elige "no imprimir", se fuerza a sí imprimir.': {
        pt: 'Regra rígida: o ticket nunca sai sem algum código escaneável. Se não houver QR e for escolhido "não imprimir", é forçado para sim.',
        en: 'Hard rule: the ticket never goes out without some scannable code. If there is no QR and "do not print" is chosen, it is forced to print.',
        ru: 'Жёсткое правило: билет никогда не выходит без сканируемого кода. Если нет QR и выбрано «не печатать», печать включается принудительно.',
    },

    // ── nodo-modal.js — Gateway ──────────────────────────────────────────────
    'Identidad del Socio': { pt: 'Identidade do Parceiro', en: 'Partner Identity', ru: 'Идентификация партнёра' },
    'Código del socio *': { pt: 'Código do parceiro *', en: 'Partner code *', ru: 'Код партнёра *' },
    'Ej: CASINO_VIVO': { pt: 'Ex.: CASINO_VIVO', en: 'E.g.: CASINO_VIVO', ru: 'Напр.: CASINO_VIVO' },
    'Identificador único. Formato: EMPRESA_PRODUCTO. No cambiar después de tener usuarios.': {
        pt: 'Identificador único. Formato: EMPRESA_PRODUTO. Não alterar após ter usuários.',
        en: 'Unique identifier. Format: COMPANY_PRODUCT. Do not change after having users.',
        ru: 'Уникальный идентификатор. Формат: КОМПАНИЯ_ПРОДУКТ. Не менять после появления пользователей.',
    },
    'Protocolo de integración': { pt: 'Protocolo de integração', en: 'Integration protocol', ru: 'Протокол интеграции' },
    'LOTO-SYSTEM (nativo)': { pt: 'LOTO-SYSTEM (nativo)', en: 'LOTO-SYSTEM (native)', ru: 'LOTO-SYSTEM (нативный)' },
    'Tigrao Wallet (estándar)': { pt: 'Tigrao Wallet (padrão)', en: 'Tigrao Wallet (standard)', ru: 'Tigrao Wallet (стандарт)' },
    'Tigrao: HMAC con campos ordenados, formato BetWin estándar. Nativo: HMAC sobre body JSON.': {
        pt: 'Tigrao: HMAC com campos ordenados, formato BetWin padrão. Nativo: HMAC sobre body JSON.',
        en: 'Tigrao: HMAC with ordered fields, standard BetWin format. Native: HMAC over JSON body.',
        ru: 'Tigrao: HMAC с упорядоченными полями, стандартный формат BetWin. Нативный: HMAC по JSON-телу.',
    },
    'URL del Frontend (Game)': { pt: 'URL do Frontend (Game)', en: 'Frontend URL (Game)', ru: 'URL фронтенда (Game)' },
    'URL donde el jugador abre el juego. Se usa para construir la gameURL en /userAuth. Dejar vacío para usar la URL por defecto.': {
        pt: 'URL onde o jogador abre o jogo. Usada para construir a gameURL em /userAuth. Deixar vazio para usar a URL padrão.',
        en: 'URL where the player opens the game. Used to build the gameURL in /userAuth. Leave empty to use the default URL.',
        ru: 'URL, где игрок открывает игру. Используется для построения gameURL в /userAuth. Оставьте пустым для URL по умолчанию.',
    },
    'Endpoints': { pt: 'Endpoints', en: 'Endpoints', ru: 'Эндпоинты' },
    'Del socio (nuestro backend llama a estas URLs)': {
        pt: 'Do parceiro (nosso backend chama essas URLs)',
        en: 'Partner\'s (our backend calls these URLs)',
        ru: 'Партнёра (наш бэкенд вызывает эти URL)',
    },
    'URL Balance *': { pt: 'URL Balance *', en: 'Balance URL *', ru: 'URL Balance *' },
    'GET — Consulta saldo. Params:': { pt: 'GET — Consulta saldo. Params:', en: 'GET — Balance query. Params:', ru: 'GET — Запрос баланса. Параметры:' },
    '. También valida tokens de auth.': { pt: '. Também valida tokens de auth.', en: '. Also validates auth tokens.', ru: '. Также проверяет токены аутентификации.' },
    'URL BetWin *': { pt: 'URL BetWin *', en: 'BetWin URL *', ru: 'URL BetWin *' },
    'POST — Apuesta + premio atómico. Body:': {
        pt: 'POST — Aposta + prêmio atômico. Body:',
        en: 'POST — Atomic bet + prize. Body:',
        ru: 'POST — Атомарная ставка + приз. Тело:',
    },
    'Nuestra (el socio redirige sus usuarios aquí)': {
        pt: 'Nossa (o parceiro redireciona seus usuários aqui)',
        en: 'Ours (the partner redirects its users here)',
        ru: 'Наш (партнёр перенаправляет своих пользователей сюда)',
    },
    'URL Auth (informativo)': { pt: 'URL Auth (informativo)', en: 'Auth URL (informational)', ru: 'URL Auth (информационный)' },
    'El socio redirige al jugador aquí con': {
        pt: 'O parceiro redireciona o jogador aqui com',
        en: 'The partner redirects the player here with',
        ru: 'Партнёр перенаправляет игрока сюда с',
    },
    'Credenciales': { pt: 'Credenciais', en: 'Credentials', ru: 'Учётные данные' },
    'Claves para autenticar y firmar las peticiones hacia el socio.': {
        pt: 'Chaves para autenticar e assinar as requisições ao parceiro.',
        en: 'Keys to authenticate and sign requests to the partner.',
        ru: 'Ключи для аутентификации и подписи запросов к партнёру.',
    },
    'API Key *': { pt: 'API Key *', en: 'API Key *', ru: 'API Key *' },
    'pk_live_xxx': { pt: 'pk_live_xxx', en: 'pk_live_xxx', ru: 'pk_live_xxx' },
    'Identifica al integrador. Tigrao: se usa en': {
        pt: 'Identifica o integrador. Tigrao: usado em',
        en: 'Identifies the integrator. Tigrao: used in',
        ru: 'Идентифицирует интегратора. Tigrao: используется в',
    },
    ' para gamelist. Nativo: header ': { pt: ' para gamelist. Nativo: header ', en: ' for gamelist. Native: header ', ru: ' для gamelist. Нативный: заголовок ' },
    'API Secret (HMAC) *': { pt: 'API Secret (HMAC) *', en: 'API Secret (HMAC) *', ru: 'API Secret (HMAC) *' },
    'sk_live_xxx': { pt: 'sk_live_xxx', en: 'sk_live_xxx', ru: 'sk_live_xxx' },
    'Ver/ocultar': { pt: 'Ver/ocultar', en: 'Show/hide', ru: 'Показать/скрыть' },
    'Firma HMAC-SHA256 para integridad y autenticación. Nunca visible en logs.': {
        pt: 'Assinatura HMAC-SHA256 para integridade e autenticação. Nunca visível em logs.',
        en: 'HMAC-SHA256 signature for integrity and authentication. Never visible in logs.',
        ru: 'Подпись HMAC-SHA256 для целостности и аутентификации. Никогда не отображается в логах.',
    },
    'Configuración Avanzada': { pt: 'Configuração Avançada', en: 'Advanced Settings', ru: 'Расширенные настройки' },
    'Operator ID': { pt: 'Operator ID', en: 'Operator ID', ru: 'Operator ID' },
    '(usa Código del socio si vacío)': { pt: '(usa Código do parceiro se vazio)', en: '(uses Partner code if empty)', ru: '(использует код партнёра, если пусто)' },
    'ID que se envía como': { pt: 'ID enviado como', en: 'ID sent as', ru: 'ID, отправляемый как' },
    ' en el protocolo Tigrao. Si vacío, usa el Código del socio.': {
        pt: ' no protocolo Tigrao. Se vazio, usa o Código do parceiro.',
        en: ' in the Tigrao protocol. If empty, uses the Partner code.',
        ru: ' в протоколе Tigrao. Если пусто, используется код партнёра.',
    },
    'Timeout (ms)': { pt: 'Timeout (ms)', en: 'Timeout (ms)', ru: 'Тайм-аут (мс)' },
    'Timeout para llamadas HTTP al socio. Default: 5000ms. Rango: 1000-30000ms.': {
        pt: 'Timeout para chamadas HTTP ao parceiro. Padrão: 5000ms. Intervalo: 1000-30000ms.',
        en: 'Timeout for HTTP calls to the partner. Default: 5000ms. Range: 1000-30000ms.',
        ru: 'Тайм-аут для HTTP-вызовов к партнёру. По умолчанию: 5000мс. Диапазон: 1000-30000мс.',
    },

    // ── nodo-modal.js — Tabs ─────────────────────────────────────────────────
    'Nombre y tipo': { pt: 'Nome e tipo', en: 'Name and type', ru: 'Название и тип' },
    'País, idioma, moneda': { pt: 'País, idioma, moeda', en: 'Country, language, currency', ru: 'Страна, язык, валюта' },
    'Localización': { pt: 'Localização', en: 'Localization', ru: 'Локализация' },
    'Dirección y horario': { pt: 'Endereço e horário', en: 'Address and hours', ru: 'Адрес и часы работы' },
    'Wallet y juegos': { pt: 'Wallet e jogos', en: 'Wallet and games', ru: 'Кошелёк и игры' },
    'Fiscal y bancario': { pt: 'Fiscal e bancário', en: 'Tax and banking', ru: 'Налоги и банк' },
    'WhatsApp y marca': { pt: 'WhatsApp e marca', en: 'WhatsApp and branding', ru: 'WhatsApp и брендинг' },
    'Ticket POS': { pt: 'Ticket POS', en: 'POS Ticket', ru: 'Билет POS' },
    'Legal e impresión': { pt: 'Legal e impressão', en: 'Legal and printing', ru: 'Юридический и печать' },

    // ── setup-wizard-engine.js ───────────────────────────────────────────────
    'Sin datos para mostrar': { pt: 'Sem dados para mostrar', en: 'No data to display', ru: 'Нет данных для отображения' },
    'Siguiente →': { pt: 'Próximo →', en: 'Next →', ru: 'Далее →' },
    'Resumen': { pt: 'Resumo', en: 'Summary', ru: 'Сводка' },
    'Confirmar datos': { pt: 'Confirmar dados', en: 'Confirm data', ru: 'Подтвердить данные' },

    // ── setup-wizard-steps-nodo.js ────────────────────────────────────────────
    'Tipo de nodo *': { pt: 'Tipo de nó *', en: 'Node type *', ru: 'Тип узла *' },
    'Define la identidad de este nodo en la jerarquía.': {
        pt: 'Define a identidade deste nó na hierarquia.',
        en: 'Defines the identity of this node in the hierarchy.',
        ru: 'Определяет идентичность этого узла в иерархии.',
    },
    'Ej: Operador Lima, PV Centro Comercial...': {
        pt: 'Ex.: Operador Lima, PV Centro Comercial...',
        en: 'E.g.: Lima Operator, Mall point of sale...',
        ru: 'Напр.: Оператор Лима, точка продаж в ТЦ...',
    },
    'Define presets fiscales y bancarios': {
        pt: 'Define presets fiscais e bancários',
        en: 'Defines tax and banking presets',
        ru: 'Определяет налоговые и банковские пресеты',
    },
    'Para formateo de montos. Vacío = hereda': {
        pt: 'Para formatação de valores. Vazio = herda',
        en: 'For amount formatting. Empty = inherits',
        ru: 'Для форматирования сумм. Пусто = наследует',
    },
    'De la interfaz. Vacío = hereda': { pt: 'Da interface. Vazio = herda', en: 'Of the interface. Empty = inherits', ru: 'Интерфейса. Пусто = наследует' },
    'Atajo para búsquedas rápidas': { pt: 'Atalho para buscas rápidas', en: 'Shortcut for quick searches', ru: 'Ярлык для быстрого поиска' },
    'Físico (local)': { pt: 'Físico (local)', en: 'Physical (venue)', ru: 'Физический (точка)' },
    'Ambulante': { pt: 'Ambulante', en: 'Mobile', ru: 'Передвижной' },
    'Empresa o franquicia que gestiona múltiples puntos de venta.': {
        pt: 'Empresa ou franquia que gerencia múltiplos pontos de venda.',
        en: 'Company or franchise that manages multiple points of sale.',
        ru: 'Компания или франшиза, управляющая несколькими точками продаж.',
    },
    'Agente que administra un grupo de puntos de venta.': {
        pt: 'Agente que administra um grupo de pontos de venda.',
        en: 'Agent that manages a group of points of sale.',
        ru: 'Агент, управляющий группой точек продаж.',
    },
    'Ubicación física o virtual donde se vende.': {
        pt: 'Localização física ou virtual onde se vende.',
        en: 'Physical or virtual location where sales happen.',
        ru: 'Физическое или виртуальное место, где осуществляется продажа.',
    },
    'Selecciona el tipo para ver su descripción.': {
        pt: 'Selecione o tipo para ver a descrição.',
        en: 'Select the type to see its description.',
        ru: 'Выберите тип, чтобы увидеть его описание.',
    },
    'Nombre, email o teléfono del responsable': {
        pt: 'Nome, e-mail ou telefone do responsável',
        en: 'Name, email or phone of the person in charge',
        ru: 'Имя, email или телефон ответственного',
    },
    'Dirección física (opcional)': { pt: 'Endereço físico (opcional)', en: 'Physical address (optional)', ru: 'Физический адрес (необязательно)' },
    'Información de contacto del responsable. Puedes completar esto después.': {
        pt: 'Informações de contato do responsável. Você pode completar depois.',
        en: 'Contact information of the person in charge. You can complete this later.',
        ru: 'Контактная информация ответственного. Вы можете заполнить это позже.',
    },
    'Datos de la ubicación física. Puedes completar esto después.': {
        pt: 'Dados da localização física. Você pode completar depois.',
        en: 'Physical location data. You can complete this later.',
        ru: 'Данные о физическом местоположении. Вы можете заполнить это позже.',
    },
    'Región / Departamento': { pt: 'Região / Departamento', en: 'Region / Department', ru: 'Регион / Департамент' },
    'Ej: Lima, São Paulo': { pt: 'Ex.: Lima, São Paulo', en: 'E.g.: Lima, São Paulo', ru: 'Напр.: Lima, São Paulo' },
    'Teléfono del local': { pt: 'Telefone do local', en: 'Venue phone', ru: 'Телефон точки' },
    'Ej: +51 999888777': { pt: 'Ex.: +51 999888777', en: 'E.g.: +51 999888777', ru: 'Напр.: +51 999888777' },
    'Horario de operación': { pt: 'Horário de operação', en: 'Operating hours', ru: 'Часы работы' },
    'Ej: Lun-Sab 9:00-21:00': { pt: 'Ex.: Seg-Sáb 9:00-21:00', en: 'E.g.: Mon-Sat 9:00-21:00', ru: 'Напр.: Пн-Сб 9:00-21:00' },
    'Email del local': { pt: 'E-mail do local', en: 'Venue email', ru: 'Email точки' },
    'local@ejemplo.com': { pt: 'local@exemplo.com', en: 'venue@example.com', ru: 'local@example.com' },
    'No especificado': { pt: 'Não especificado', en: 'Not specified', ru: 'Не указано' },
    'No especificada': { pt: 'Não especificada', en: 'Not specified', ru: 'Не указано' },
    '¿Cómo va a entrar el promotor a su panel? Este paso es obligatorio: el promotor nace con su usuario resuelto, nunca a medias.': {
        pt: 'Como o promotor vai acessar o painel? Esta etapa é obrigatória: o promotor nasce com seu usuário resolvido, nunca incompleto.',
        en: 'How will the promoter access their panel? This step is mandatory: the promoter is created with their user fully resolved, never half-done.',
        ru: 'Как промоутер будет входить в свою панель? Этот шаг обязателен: промоутер создаётся с полностью настроенным пользователем, никогда наполовину.',
    },
    'Nuevo usuario con su correo': { pt: 'Novo usuário com seu e-mail', en: 'New user with their email', ru: 'Новый пользователь со своим email' },
    'Escribís el correo del promotor. Él crea su contraseña al entrar a su enlace.': {
        pt: 'Você informa o e-mail do promotor. Ele cria a senha ao acessar o link.',
        en: 'You enter the promoter\'s email. They create their password when opening their link.',
        ru: 'Вы вводите email промоутера. Он создаёт пароль при переходе по своей ссылке.',
    },
    'Autogestión (sin correo)': { pt: 'Autogestão (sem e-mail)', en: 'Self-service (no email)', ru: 'Самостоятельно (без email)' },
    'El promotor verifica su correo con un código y crea su contraseña al entrar a su enlace.': {
        pt: 'O promotor verifica o e-mail com um código e cria a senha ao acessar o link.',
        en: 'The promoter verifies their email with a code and creates their password when opening their link.',
        ru: 'Промоутер подтверждает свой email кодом и создаёт пароль при переходе по своей ссылке.',
    },
    'Usuario existente': { pt: 'Usuário existente', en: 'Existing user', ru: 'Существующий пользователь' },
    'Asignás un usuario cajero que ya existe en tu red.': {
        pt: 'Você atribui um operador de caixa que já existe na sua rede.',
        en: 'You assign a till operator that already exists in your network.',
        ru: 'Вы назначаете оператора кассы, который уже есть в вашей сети.',
    },
    'Correo del promotor *': { pt: 'E-mail do promotor *', en: 'Promoter\'s email *', ru: 'Email промоутера *' },
    'promotor@ejemplo.com': { pt: 'promotor@exemplo.com', en: 'promoter@example.com', ru: 'promoter@example.com' },
    'Será su usuario de ingreso. Él fija su propia contraseña.': {
        pt: 'Será o usuário de acesso. Ele define a própria senha.',
        en: 'It will be their login user. They set their own password.',
        ru: 'Это будет его логин. Он устанавливает собственный пароль.',
    },
    'Usuario existente *': { pt: 'Usuário existente *', en: 'Existing user *', ru: 'Существующий пользователь *' },
    'Cargando usuarios...': { pt: 'Carregando usuários...', en: 'Loading users...', ru: 'Загрузка пользователей...' },
    'No hay usuarios ligables (sin caja y con autoridad acá)': {
        pt: 'Não há usuários vinculáveis (sem caixa e com autoridade aqui)',
        en: 'No linkable users (without a till and with authority here)',
        ru: 'Нет привязываемых пользователей (без кассы и с полномочиями здесь)',
    },
    'sin correo': { pt: 'sem e-mail', en: 'no email', ru: 'без email' },
    'No se pudieron cargar los usuarios': {
        pt: 'Não foi possível carregar os usuários',
        en: 'Could not load users',
        ru: 'Не удалось загрузить пользователей',
    },
    'Usuarios cajero de tu red. El usuario queda ligado a la caja enlace del promotor.': {
        pt: 'Operadores de caixa da sua rede. O usuário fica vinculado à caixa enlace do promotor.',
        en: 'Till operators in your network. The user is linked to the promoter\'s link till.',
        ru: 'Операторы кассы вашей сети. Пользователь привязывается к кассе-ссылке промоутера.',
    },
    'Selecciona el tipo de nodo': { pt: 'Selecione o tipo de nó', en: 'Select the node type', ru: 'Выберите тип узла' },
    'El nombre es requerido': { pt: 'O nome é obrigatório', en: 'The name is required', ru: 'Название обязательно' },
    'Elegí cómo va a entrar el promotor': {
        pt: 'Escolha como o promotor vai acessar',
        en: 'Choose how the promoter will log in',
        ru: 'Выберите, как промоутер будет входить',
    },
    'Ingresá un correo válido para el promotor': {
        pt: 'Informe um e-mail válido para o promotor',
        en: 'Enter a valid email for the promoter',
        ru: 'Введите действительный email для промоутера',
    },
    'Seleccioná el usuario existente a ligar': {
        pt: 'Selecione o usuário existente para vincular',
        en: 'Select the existing user to link',
        ru: 'Выберите существующего пользователя для привязки',
    },
    'Nuevo usuario': { pt: 'Novo usuário', en: 'New user', ru: 'Новый пользователь' },
    'Nuevo usuario:': { pt: 'Novo usuário:', en: 'New user:', ru: 'Новый пользователь:' },
    'Autogestión (verifica su correo al entrar)': {
        pt: 'Autogestão (verifica o e-mail ao entrar)',
        en: 'Self-service (verifies their email on login)',
        ru: 'Самостоятельно (подтверждает email при входе)',
    },
    'Usuario existente ligado': { pt: 'Usuário existente vinculado', en: 'Existing user linked', ru: 'Существующий пользователь привязан' },
    'Promotor Digital creado: nodo + caja enlace + usuario': {
        pt: 'Promotor Digital criado: nó + caixa enlace + usuário',
        en: 'Digital Promoter created: node + link till + user',
        ru: 'Цифровой промоутер создан: узел + касса-ссылка + пользователь',
    },
    'Error al aprovisionar el promotor': {
        pt: 'Erro ao provisionar o promotor',
        en: 'Error provisioning the promoter',
        ru: 'Ошибка при создании промоутера',
    },
    'Error al crear nodo': { pt: 'Erro ao criar o nó', en: 'Error creating node', ru: 'Ошибка при создании узла' },
    'Datos de contacto': { pt: 'Dados de contato', en: 'Contact data', ru: 'Контактные данные' },
    'Tipo, nombre y región': { pt: 'Tipo, nome e região', en: 'Type, name and region', ru: 'Тип, название и регион' },
    'Usuario del promotor': { pt: 'Usuário do promotor', en: 'Promoter\'s user', ru: 'Пользователь промоутера' },

    // ── setup-wizard-steps-device.js ──────────────────────────────────────────
    'Verificar dispositivo': { pt: 'Verificar dispositivo', en: 'Verify device', ru: 'Проверить устройство' },
    'Ingresa el código que muestra el dispositivo en pantalla.': {
        pt: 'Informe o código exibido pelo dispositivo na tela.',
        en: 'Enter the code shown by the device on screen.',
        ru: 'Введите код, отображаемый устройством на экране.',
    },
    'Código del dispositivo *': { pt: 'Código do dispositivo *', en: 'Device code *', ru: 'Код устройства *' },
    'No se pudo conectar con el servidor': {
        pt: 'Não foi possível conectar ao servidor',
        en: 'Could not connect to the server',
        ru: 'Не удалось подключиться к серверу',
    },
    'Código no encontrado o ya autorizado': {
        pt: 'Código não encontrado ou já autorizado',
        en: 'Code not found or already authorized',
        ru: 'Код не найден или уже авторизован',
    },
    'Ingresa un código de al menos 6 dígitos': {
        pt: 'Informe um código de pelo menos 6 dígitos',
        en: 'Enter a code of at least 6 digits',
        ru: 'Введите код не менее 6 цифр',
    },
    'Código no verificado. Espera a que se valide.': {
        pt: 'Código não verificado. Aguarde a validação.',
        en: 'Code not verified. Wait for it to validate.',
        ru: 'Код не проверен. Дождитесь проверки.',
    },
    '✓ Dispositivo encontrado': { pt: '✓ Dispositivo encontrado', en: '✓ Device found', ru: '✓ Устройство найдено' },
    'Asignar punto de venta': { pt: 'Atribuir ponto de venda', en: 'Assign point of sale', ru: 'Назначить точку продаж' },
    'Selecciona el punto de venta donde estará este dispositivo.': {
        pt: 'Selecione o ponto de venda onde ficará este dispositivo.',
        en: 'Select the point of sale where this device will be.',
        ru: 'Выберите точку продаж, где будет находиться это устройство.',
    },
    'Punto de Venta *': { pt: 'Ponto de Venda *', en: 'Point of Sale *', ru: 'Точка продаж *' },
    'Buscar punto de venta...': { pt: 'Buscar ponto de venda...', en: 'Search point of sale...', ru: 'Поиск точки продаж...' },
    'Nombre del dispositivo': { pt: 'Nome do dispositivo', en: 'Device name', ru: 'Название устройства' },
    'Ej: Pantalla Principal, Caja 1...': {
        pt: 'Ex.: Tela Principal, Caixa 1...',
        en: 'E.g.: Main Screen, Till 1...',
        ru: 'Напр.: Главный экран, Касса 1...',
    },
    'Opcional. Si no lo indicas, se usará el serial.': {
        pt: 'Opcional. Se não informar, será usado o serial.',
        en: 'Optional. If you don\'t specify it, the serial will be used.',
        ru: 'Необязательно. Если не указать, будет использован серийный номер.',
    },
    'Selecciona un punto de venta': { pt: 'Selecione um ponto de venda', en: 'Select a point of sale', ru: 'Выберите точку продаж' },
    '(auto)': { pt: '(auto)', en: '(auto)', ru: '(авто)' },
    'Sorteos a mostrar': { pt: 'Sorteios a exibir', en: 'Draws to display', ru: 'Розыгрыши для показа' },
    'Selecciona el tipo de juego y los sorteos que mostrará este dispositivo.': {
        pt: 'Selecione o tipo de jogo e os sorteios que este dispositivo exibirá.',
        en: 'Select the game type and the draws this device will display.',
        ru: 'Выберите тип игры и розыгрыши, которые будет показывать это устройство.',
    },
    'Tipo de Juego *': { pt: 'Tipo de Jogo *', en: 'Game Type *', ru: 'Тип игры *' },
    'Sin sorteos disponibles': { pt: 'Sem sorteios disponíveis', en: 'No draws available', ru: 'Нет доступных розыгрышей' },
    'Sorteos *': { pt: 'Sorteios *', en: 'Draws *', ru: 'Розыгрыши *' },
    'Punto de venta y nombre': { pt: 'Ponto de venda e nome', en: 'Point of sale and name', ru: 'Точка продаж и название' },
    'Selecciona el punto de venta donde operará esta caja.': {
        pt: 'Selecione o ponto de venda onde esta caixa operará.',
        en: 'Select the point of sale where this till will operate.',
        ru: 'Выберите точку продаж, где будет работать эта касса.',
    },
    'Nombre de la caja *': { pt: 'Nome do caixa *', en: 'Till name *', ru: 'Название кассы *' },
    'Ej: Caja Principal, Caja Lateral...': {
        pt: 'Ex.: Caixa Principal, Caixa Lateral...',
        en: 'E.g.: Main Till, Side Till...',
        ru: 'Напр.: Главная касса, Боковая касса...',
    },
    'El nombre de la caja es requerido': { pt: 'O nome do caixa é obrigatório', en: 'The till name is required', ru: 'Название кассы обязательно' },
    'Sorteos y restricciones': { pt: 'Sorteios e restrições', en: 'Draws and restrictions', ru: 'Розыгрыши и ограничения' },
    'Configura qué juegos y sorteos podrá vender esta caja.': {
        pt: 'Configure quais jogos e sorteios esta caixa poderá vender.',
        en: 'Configure which games and draws this till can sell.',
        ru: 'Настройте, какие игры и розыгрыши может продавать эта касса.',
    },
    'El Punto de Venta no tiene juegos configurados. Esta caja no podrá vender tickets.': {
        pt: 'O Ponto de Venda não tem jogos configurados. Esta caixa não poderá vender tickets.',
        en: 'The Point of Sale has no games configured. This till will not be able to sell tickets.',
        ru: 'В точке продаж не настроены игры. Эта касса не сможет продавать билеты.',
    },
    'Hereda del Punto de Venta': { pt: 'Herda do Ponto de Venda', en: 'Inherits from the Point of Sale', ru: 'Наследует от точки продаж' },
    'Wallet y tickets': { pt: 'Wallet e tickets', en: 'Wallet and tickets', ru: 'Кошелёк и билеты' },
    'Define qué operaciones puede realizar esta caja.': {
        pt: 'Defina quais operações esta caixa pode realizar.',
        en: 'Define which operations this till can perform.',
        ru: 'Определите, какие операции может выполнять эта касса.',
    },
    'Operaciones:': { pt: 'Operações:', en: 'Operations:', ru: 'Операции:' },
    'Sin operaciones configuradas en el PV': {
        pt: 'Sem operações configuradas no PV',
        en: 'No operations configured in the POS',
        ru: 'В точке продаж не настроены операции',
    },
    'Elegir manualmente qué operaciones habilitar': {
        pt: 'Escolher manualmente quais operações habilitar',
        en: 'Manually choose which operations to enable',
        ru: 'Выбрать вручную, какие операции включить',
    },
    'Depósitos y retiros de saldo a clientes': {
        pt: 'Depósitos e saques de saldo de clientes',
        en: 'Customer balance deposits and withdrawals',
        ru: 'Депозиты и выводы баланса клиентов',
    },
    'Tickets de apuestas al portador': { pt: 'Tickets de apostas ao portador', en: 'Bearer bet tickets', ru: 'Билеты ставок на предъявителя' },
    'El Punto de Venta no tiene operaciones disponibles para personalizar.': {
        pt: 'O Ponto de Venda não tem operações disponíveis para personalizar.',
        en: 'The Point of Sale has no operations available to customize.',
        ru: 'В точке продаж нет операций, доступных для настройки.',
    },
    'Debe haber al menos una operación habilitada': {
        pt: 'Deve haver pelo menos uma operação habilitada',
        en: 'There must be at least one enabled operation',
        ru: 'Должна быть включена хотя бы одна операция',
    },
    ' (heredado)': { pt: ' (herdado)', en: ' (inherited)', ru: ' (унаследовано)' },
    ' (personalizado)': { pt: ' (personalizado)', en: ' (customized)', ru: ' (настроено)' },
    'Operaciones': { pt: 'Operações', en: 'Operations', ru: 'Операции' },
    'Error al autorizar dispositivo': { pt: 'Erro ao autorizar dispositivo', en: 'Error authorizing device', ru: 'Ошибка авторизации устройства' },
    'Error al autorizar caja': { pt: 'Erro ao autorizar caixa', en: 'Error authorizing till', ru: 'Ошибка авторизации кассы' },
    'Caja autorizada': { pt: 'Caixa autorizada', en: 'Till authorized', ru: 'Касса авторизована' },

    // ── setup-wizard-steps-cupon-campana.js ───────────────────────────────────
    'Código, nombre y descripción': { pt: 'Código, nome e descrição', en: 'Code, name and description', ru: 'Код, название и описание' },
    'Identificá la campaña con un código único y un nombre legible.': {
        pt: 'Identifique a campanha com um código único e um nome legível.',
        en: 'Identify the campaign with a unique code and a readable name.',
        ru: 'Идентифицируйте кампанию уникальным кодом и понятным названием.',
    },
    'Código *': { pt: 'Código *', en: 'Code *', ru: 'Код *' },
    'Ej: BIENVENIDA-2026, LOT-LIMA-Q1': {
        pt: 'Ex.: BIENVENIDA-2026, LOT-LIMA-Q1',
        en: 'E.g.: BIENVENIDA-2026, LOT-LIMA-Q1',
        ru: 'Напр.: BIENVENIDA-2026, LOT-LIMA-Q1',
    },
    'Letras, números, guión bajo y guión medio. Hasta': {
        pt: 'Letras, números, sublinhado e hífen. Até',
        en: 'Letters, numbers, underscore and hyphen. Up to',
        ru: 'Буквы, цифры, подчёркивание и дефис. До',
    },
    ' caracteres.': { pt: ' caracteres.', en: ' characters.', ru: ' символов.' },
    'Ej: Bienvenida 2026 - bonus 10 PEN': {
        pt: 'Ex.: Bienvenida 2026 - bonus 10 PEN',
        en: 'E.g.: Welcome 2026 - bonus 10 PEN',
        ru: 'Напр.: Welcome 2026 - bonus 10 PEN',
    },
    'Para qué sirve esta campaña, dónde se reparten los cupones, etc.': {
        pt: 'Para que serve esta campanha, onde são distribuídos os cupons, etc.',
        en: 'What this campaign is for, where the coupons are distributed, etc.',
        ru: 'Для чего эта кампания, где раздаются купоны и т. д.',
    },
    'El código es requerido': { pt: 'O código é obrigatório', en: 'The code is required', ru: 'Код обязателен' },
    'Código solo permite letras, números, guión bajo y guión medio': {
        pt: 'O código só permite letras, números, sublinhado e hífen',
        en: 'The code only allows letters, numbers, underscore and hyphen',
        ru: 'Код допускает только буквы, цифры, подчёркивание и дефис',
    },
    'Código no puede superar': { pt: 'O código não pode superar', en: 'The code cannot exceed', ru: 'Код не может превышать' },
    ' caracteres': { pt: ' caracteres', en: ' characters', ru: ' символов' },
    'Nombre no puede superar': { pt: 'O nome não pode superar', en: 'The name cannot exceed', ru: 'Название не может превышать' },
    'Descripción no puede superar': { pt: 'A descrição não pode superar', en: 'The description cannot exceed', ru: 'Описание не может превышать' },
    'Qué premio se acredita y desde qué nodo se reparten': {
        pt: 'Qual prêmio é creditado e de qual nó são distribuídos',
        en: 'What prize is credited and from which node they are distributed',
        ru: 'Какой приз начисляется и из какого узла они раздаются',
    },
    'Selecciona la promoción que se aplicará al canjear y el nodo desde donde se reparten los cupones (los productores deben estar bajo este nodo).': {
        pt: 'Selecione a promoção que será aplicada ao resgatar e o nó de onde são distribuídos os cupons (os produtores devem estar abaixo deste nó).',
        en: 'Select the promotion that will be applied on redemption and the node from which the coupons are distributed (the producers must be under this node).',
        ru: 'Выберите промоакцию, которая применяется при погашении, и узел, из которого раздаются купоны (производители должны находиться под этим узлом).',
    },
    'Promoción *': { pt: 'Promoção *', en: 'Promotion *', ru: 'Промоакция *' },
    'Cargando promociones...': { pt: 'Carregando promoções...', en: 'Loading promotions...', ru: 'Загрузка промоакций...' },
    'Solo promociones con trigger': { pt: 'Somente promoções com gatilho', en: 'Only promotions with a trigger', ru: 'Только промоакции с триггером' },
    'Si no aparece, créala primero en la pestaña Promociones.': {
        pt: 'Se não aparecer, crie-a primeiro na aba Promoções.',
        en: 'If it doesn\'t appear, create it first in the Promotions tab.',
        ru: 'Если не отображается, сначала создайте её на вкладке «Промоакции».',
    },
    'Nodo de scope *': { pt: 'Nó de escopo *', en: 'Scope node *', ru: 'Узел области *' },
    'Solo cajeros/PVs descendientes de este nodo podrán emitir o canjear los cupones.': {
        pt: 'Somente operadores de caixa/PVs descendentes deste nó poderão emitir ou resgatar os cupons.',
        en: 'Only till operators/POSs descending from this node will be able to issue or redeem the coupons.',
        ru: 'Только операторы кассы/точки продаж, относящиеся к этому узлу, смогут выпускать или погашать купоны.',
    },
    'Error cargando promociones o nodos': {
        pt: 'Erro ao carregar promoções ou nós',
        en: 'Error loading promotions or nodes',
        ru: 'Ошибка при загрузке промоакций или узлов',
    },
    'Esperá a que carguen las opciones': {
        pt: 'Aguarde as opções carregarem',
        en: 'Wait for the options to load',
        ru: 'Дождитесь загрузки параметров',
    },
    'Seleccionar la promoción': { pt: 'Selecione a promoção', en: 'Select the promotion', ru: 'Выберите промоакцию' },
    'Seleccionar el nodo de scope': { pt: 'Selecione o nó de escopo', en: 'Select the scope node', ru: 'Выберите узел области' },
    'Promoción': { pt: 'Promoção', en: 'Promotion', ru: 'Промоакция' },
    'Scope': { pt: 'Escopo', en: 'Scope', ru: 'Область' },
    'Cómo se distribuyen los cupones y cuántos': {
        pt: 'Como os cupons são distribuídos e quantos',
        en: 'How the coupons are distributed and how many',
        ru: 'Как распределяются купоны и сколько их',
    },
    'Elegí cómo se reparten los cupones. La cantidad fija el límite total de cupones emisibles bajo esta campaña.': {
        pt: 'Escolha como os cupons são distribuídos. A quantidade define o limite total de cupons emissíveis sob esta campanha.',
        en: 'Choose how the coupons are distributed. The quantity sets the total limit of coupons issuable under this campaign.',
        ru: 'Выберите, как распределяются купоны. Количество задаёт общий лимит купонов, выпускаемых в рамках этой кампании.',
    },
    'Modo de emisión *': { pt: 'Modo de emissão *', en: 'Issuance mode *', ru: 'Режим выпуска *' },
    'Cantidad total *': { pt: 'Quantidade total *', en: 'Total quantity *', ru: 'Общее количество *' },
    'Ej: 500': { pt: 'Ex.: 500', en: 'E.g.: 500', ru: 'Напр.: 500' },
    'Una vez emitidos N cupones, la campaña se agota. Solo se puede aumentar después (no reducir bajo lo emitido).': {
        pt: 'Após emitidos N cupons, a campanha se esgota. Só é possível aumentar depois (não reduzir abaixo do emitido).',
        en: 'Once N coupons are issued, the campaign runs out. It can only be increased later (not reduced below what was issued).',
        ru: 'После выпуска N купонов кампания исчерпывается. Позже можно только увеличить (не уменьшить ниже выпущенного).',
    },
    'Tickets físicos impresos con código + QR. Útil para reparto en mostrador.': {
        pt: 'Tickets físicos impressos com código + QR. Útil para distribuição no balcão.',
        en: 'Physical printed tickets with code + QR. Useful for counter distribution.',
        ru: 'Физические печатные билеты с кодом + QR. Удобно для раздачи на стойке.',
    },
    'El cajero genera 1 QR en pantalla del POS, el cliente lo escanea ahí mismo.': {
        pt: 'O operador de caixa gera 1 QR na tela do POS, o cliente o escaneia no momento.',
        en: 'The till operator generates 1 QR on the POS screen, the customer scans it right there.',
        ru: 'Оператор кассы генерирует 1 QR на экране POS, клиент сканирует его на месте.',
    },
    'Lluvia en TV': { pt: 'Chuva na TV', en: 'TV rain', ru: 'Дождь на ТВ' },
    'La TV del local muestra una lluvia de QRs. El cliente escanea en vivo.': {
        pt: 'A TV do local exibe uma chuva de QRs. O cliente escaneia ao vivo.',
        en: 'The venue TV shows a rain of QRs. The customer scans live.',
        ru: 'Телевизор в точке показывает дождь из QR-кодов. Клиент сканирует вживую.',
    },
    'Seleccioná un modo de emisión': { pt: 'Selecione um modo de emissão', en: 'Select an issuance mode', ru: 'Выберите режим выпуска' },
    'La cantidad total debe ser un entero positivo': {
        pt: 'A quantidade total deve ser um inteiro positivo',
        en: 'The total quantity must be a positive integer',
        ru: 'Общее количество должно быть положительным целым числом',
    },
    'La cantidad total no puede superar 100.000 (límite de seguridad)': {
        pt: 'A quantidade total não pode superar 100.000 (limite de segurança)',
        en: 'The total quantity cannot exceed 100,000 (safety limit)',
        ru: 'Общее количество не может превышать 100 000 (предел безопасности)',
    },
    'Cantidad': { pt: 'Quantidade', en: 'Quantity', ru: 'Количество' },
    'Cuándo está activa la campaña y cuánto dura cada cupón': {
        pt: 'Quando a campanha está ativa e quanto tempo dura cada cupom',
        en: 'When the campaign is active and how long each coupon lasts',
        ru: 'Когда кампания активна и сколько действует каждый купон',
    },
    'La vigencia limita cuándo se pueden EMITIR cupones de esta campaña. El TTL es cuánto vive cada cupón individual desde su emisión.': {
        pt: 'A vigência limita quando os cupons desta campanha podem ser EMITIDOS. O TTL é quanto tempo cada cupom individual vive desde sua emissão.',
        en: 'The validity period limits when coupons of this campaign can be ISSUED. The TTL is how long each individual coupon lives from its issuance.',
        ru: 'Срок действия ограничивает, когда можно ВЫПУСКАТЬ купоны этой кампании. TTL — это срок жизни каждого отдельного купона с момента выпуска.',
    },
    'Vigencia desde': { pt: 'Vigência desde', en: 'Valid from', ru: 'Действует с' },
    'Vacío = empieza al crear': { pt: 'Vazio = começa ao criar', en: 'Empty = starts on creation', ru: 'Пусто = начинается при создании' },
    'Vigencia hasta': { pt: 'Vigência até', en: 'Valid until', ru: 'Действует до' },
    'Vacío = sin fecha de cierre': { pt: 'Vazio = sem data de encerramento', en: 'Empty = no closing date', ru: 'Пусто = без даты окончания' },
    'TTL del cupón (horas) *': { pt: 'TTL do cupom (horas) *', en: 'Coupon TTL (hours) *', ru: 'TTL купона (часы) *' },
    'Entre': { pt: 'Entre', en: 'Between', ru: 'От' },
    ' hora y ': { pt: ' hora e ', en: ' hour and ', ru: ' часа до ' },
    ' horas (1 año). Default: 720h (30 días).': {
        pt: ' horas (1 ano). Padrão: 720h (30 dias).',
        en: ' hours (1 year). Default: 720h (30 days).',
        ru: ' часов (1 год). По умолчанию: 720ч (30 дней).',
    },
    'TTL debe estar entre': { pt: 'TTL deve estar entre', en: 'TTL must be between', ru: 'TTL должен быть между' },
    ' y ': { pt: ' e ', en: ' and ', ru: ' и ' },
    ' horas': { pt: ' horas', en: ' hours', ru: ' часов' },
    'Vigencia desde debe ser anterior a vigencia hasta': {
        pt: 'A vigência desde deve ser anterior à vigência até',
        en: 'Valid from must be earlier than valid until',
        ru: '«Действует с» должно быть раньше «Действует до»',
    },
    '— (al crear)': { pt: '— (ao criar)', en: '— (on creation)', ru: '— (при создании)' },
    '— (sin cierre)': { pt: '— (sem encerramento)', en: '— (no closing)', ru: '— (без окончания)' },
    'TTL del cupón': { pt: 'TTL do cupom', en: 'Coupon TTL', ru: 'TTL купона' },
    'Vigencia + TTL': { pt: 'Vigência + TTL', en: 'Validity + TTL', ru: 'Срок действия + TTL' },
    'Cuándo está activa y cuánto dura cada cupón': {
        pt: 'Quando está ativa e quanto dura cada cupom',
        en: 'When it is active and how long each coupon lasts',
        ru: 'Когда активна и сколько действует каждый купон',
    },
    'Promo + Scope': { pt: 'Promo + Escopo', en: 'Promo + Scope', ru: 'Промо + Область' },
    'Modo + Cantidad': { pt: 'Modo + Quantidade', en: 'Mode + Quantity', ru: 'Режим + Количество' },

    // ── setup-wizard-steps-cupon-campana.js — toast confirm ──────────────────
    'Campaña': { pt: 'Campanha', en: 'Campaign', ru: 'Кампания' },
    'creada (id': { pt: 'criada (id', en: 'created (id', ru: 'создана (id' },

    // ── fuzzy-search.js ──────────────────────────────────────────────────────
    '+ Crear nuevo': { pt: '+ Criar novo', en: '+ Create new', ru: '+ Создать новый' },

    // ── setup-wizard-steps-crear-dispositivo.js ──────────────────────────────
    'Identificar el dispositivo': { pt: 'Identificar o dispositivo', en: 'Identify the device', ru: 'Идентифицировать устройство' },
    'Nombre del dispositivo *': { pt: 'Nome do dispositivo *', en: 'Device name *', ru: 'Название устройства *' },
    'Nuevo dispositivo': { pt: 'Novo dispositivo', en: 'New device', ru: 'Новое устройство' },
    'POS web': { pt: 'POS web', en: 'Web POS', ru: 'Веб-POS' },
    'TV web': { pt: 'TV web', en: 'Web TV', ru: 'Веб-ТВ' },
    'TV Android (APK)': { pt: 'TV Android (APK)', en: 'Android TV (APK)', ru: 'Android TV (APK)' },
    'TV web (link)': { pt: 'TV web (link)', en: 'Web TV (link)', ru: 'Веб-ТВ (ссылка)' },
    'caja POS Android (APK)': { pt: 'caixa POS Android (APK)', en: 'Android POS till (APK)', ru: 'POS-касса Android (APK)' },
    'caja web (link)': { pt: 'caixa web (link)', en: 'web till (link)', ru: 'веб-касса (ссылка)' },
    'Sorteos a asignar': { pt: 'Sorteios a atribuir', en: 'Draws to assign', ru: 'Розыгрыши для назначения' },
    'Vas a crear un nuevo dispositivo para': { pt: 'Você vai criar um novo dispositivo para', en: 'You are going to create a new device for', ru: 'Вы создаёте новое устройство для' },
    'Tipo': { pt: 'Tipo', en: 'Type', ru: 'Тип' },
    'El Punto de Venta no tiene juegos asignados todavía. Asigná juegos al PV antes de crear este dispositivo.': {
        pt: 'O Ponto de Venda ainda não tem jogos atribuídos. Atribua jogos ao PV antes de criar este dispositivo.',
        en: 'The Point of Sale has no games assigned yet. Assign games to the POS before creating this device.',
        ru: 'В точке продаж пока нет назначенных игр. Назначьте игры точке перед созданием этого устройства.',
    },
    'Podés asignarlo desde la sección "Juegos y Sorteos" de la ficha del nodo.': {
        pt: 'Você pode atribuí-lo pela seção "Jogos e Sorteios" da ficha do nó.',
        en: 'You can assign it from the "Games and Draws" section of the node\'s profile.',
        ru: 'Вы можете назначить это в разделе «Игры и розыгрыши» карточки узла.',
    },
    'El Punto de Venta no tiene juegos asignados. No se puede crear el dispositivo.': {
        pt: 'O Ponto de Venda não tem jogos atribuídos. Não é possível criar o dispositivo.',
        en: 'The Point of Sale has no games assigned. The device cannot be created.',
        ru: 'В точке продаж нет назначенных игр. Устройство не может быть создано.',
    },
    'Error de red al cargar juegos y sorteos. Verificá tu conexión.': {
        pt: 'Erro de rede ao carregar jogos e sorteios. Verifique sua conexão.',
        en: 'Network error loading games and draws. Check your connection.',
        ru: 'Сетевая ошибка при загрузке игр и розыгрышей. Проверьте подключение.',
    },
    'Error cargando juegos y sorteos del punto de venta.': {
        pt: 'Erro ao carregar jogos e sorteios do ponto de venda.',
        en: 'Error loading games and draws of the point of sale.',
        ru: 'Ошибка при загрузке игр и розыгрышей точки продаж.',
    },
    'Seleccioná el juego y los sorteos que operará este dispositivo.': {
        pt: 'Selecione o jogo e os sorteios que este dispositivo operará.',
        en: 'Select the game and the draws this device will operate.',
        ru: 'Выберите игру и розыгрыши, с которыми будет работать это устройство.',
    },
    'Seleccioná un tipo de juego': { pt: 'Selecione um tipo de jogo', en: 'Select a game type', ru: 'Выберите тип игры' },
    'Seleccioná al menos un sorteo': { pt: 'Selecione pelo menos um sorteio', en: 'Select at least one draw', ru: 'Выберите хотя бы один розыгрыш' },
    'El nombre del dispositivo es requerido': { pt: 'O nome do dispositivo é obrigatório', en: 'The device name is required', ru: 'Название устройства обязательно' },
    'Sin sorteos disponibles para este juego.': { pt: 'Sem sorteios disponíveis para este jogo.', en: 'No draws available for this game.', ru: 'Нет доступных розыгрышей для этой игры.' },
};
